import { Box, Typography } from '@mui/material'
import { Entity } from 'utils/hooks/usePermissions'
import { NoPermission } from 'pages/NoPermission/NoPermission'
import { useDataPermissions } from '../hooks/useDataPermissions'

const FloursData = () => {
  // Check permissions using the custom hook
  const { hasPermission, showNoPermission } = useDataPermissions(
    Entity.FLOURS,
    'SHOW_FLOURS'
  )

  // If user doesn't have permission to view flours data, show no permission page
  if (!hasPermission && showNoPermission) {
    return <NoPermission />
  }

  return (
    <Box>
      <Box>
        <Typography>FloursData</Typography>
      </Box>
    </Box>
  )
}

export default FloursData
